import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BookmarksComponent } from '../bookmarks/bookmarks';
import { NotesComponent } from '../notes/notes';
import { QuestionsListComponent } from '../questions-list/questions-list';
import { TocComponent } from '../toc/toc';
import { FeatureFlagsService } from '../../../services/feature-flags/feature-flags';
import { MetadataService } from '../../../services/metadata/metadata';

@Component({
  selector: 'nr-navigation-tabs',
  imports: [
    BookmarksComponent,
    TocComponent,
    NotesComponent,
    QuestionsListComponent,
    TranslatePipe,
  ],
  templateUrl: './navigation-tabs.html',
  styleUrl: './navigation-tabs.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NavigationTabsComponent {
  private readonly metadataService = inject(MetadataService);

  readonly featureFlags = inject(FeatureFlagsService);
  readonly nrNavigated = output();
  readonly showQuestions = computed(
    () => this.metadataService.canManageQuestions() && this.featureFlags.isEnabled('questions')(),
  );

  handleNavigation(): void {
    this.nrNavigated.emit();
  }
}
